export const formatQuizData = (data) => {
  return data.map((d) => {
    let possibleResultsIds
    if (typeof d.possibleResultsIds === "string") {
      possibleResultsIds = d.possibleResultsIds
        .split(",")
        .filter((d) => d !== "")
        .map((d) => Number(d))
    } else possibleResultsIds = [Number(d.possibleResultsIds)]

    const nextQId = typeof d.nextQId === "number" ? d.nextQId : null

    return {
      qId: Number(d.qId),
      question: String(d.question),
      response: String(d.response),
      possibleResultsIds,
      nextQId,
    }
  })
}

export const formatFinalData = (rawData) => {
  const data = formatQuizData(rawData)
  const allQIds = [...new Set(data.map((d) => d.qId))]
  return allQIds.map((id) => {
    const options = data.filter((d) => d.qId === id)
    return {
      qId: id,
      text: options[0].question,
      options: options.map((option) => ({
        text: option.response,
        nextQId: option.nextQId,
        possibleResultsIds: option.possibleResultsIds,
      })),
    }
  })
}

export const formatUserChoicesData = (data, questionData) => {
  if (data.length === 0) {
    return [formatShowNewQuestion(questionData)]
  }
  const oldQuestion = data[data.length - 1]
  return [oldQuestion, questionData]
}

export const formatShowNewQuestion = (questionData) => ({
  ...questionData,
  showQuestion: true,
  options: questionData.options.map((d, i) => ({
    ...d,
    optionId: i,
    selected: false,
  })),
})
